import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import router from './router'
import 'ant-design-vue/dist/reset.css';
import '@/assets/styles/antd-variables.less'
import "@/assets/styles/global.less";
import { createPinia } from 'pinia'
import 'video.js/dist/video-js.css'

const app = createApp(App)
app.use(Antd);
app.use(router)
app.use(createPinia())
app.mount('#app')


const observer = new ResizeObserver(() => {});
observer.observe(document.body);